<template>
  <section class="page-container mg-t-10">
    <div class="flex flex-align-center flex-sb-center mg-b-20">
      <div class="total">
        <span class="num fs-24">{{team_total}}</span>
        <span class="fs-12">Teams</span>
      </div>
      <v-button
        gray
        @click="addTeam">Add Team</v-button>
    </div>
    <!--    &lt;!&ndash;    <div class="filter-top">&ndash;&gt;-->
    <!--    &lt;!&ndash;      &lt;!&ndash;      <span>Search</span>&ndash;&gt;&ndash;&gt;-->
    <!--    &lt;!&ndash;      <v-input&ndash;&gt;-->
    <!--    &lt;!&ndash;        v-model="search"&ndash;&gt;-->
    <!--    &lt;!&ndash;        placeholder="mobile, email"&ndash;&gt;-->
    <!--    &lt;!&ndash;        @keyEnter="filterData" />&ndash;&gt;-->
    <!--    &lt;!&ndash;    </div>&ndash;&gt;-->
    <!--    <div class="filter-card">-->
    <!--      <div class="filter-main">-->
    <!--        <div class="filter-left">-->
    <!--          <div class="form-item">-->
    <!--            <span>Creation Date</span>-->
    <!--            <v-date-picker-->
    <!--              v-model="date"-->
    <!--              type="daterange"-->
    <!--              @change="changeDate" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="transparent">
      <el-table
        id="myTable"
        ref="sortable"
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        row-key="id"
        @row-click="handleRow"
      >
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="people-group"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin time-text">
              <!--              <span>-->
              <span>{{ row.created_date}}</span><br>
              <span> {{ row.created_time }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Team">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <p class="break-word">{{row.team_nm}}</p>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          label="Voted#">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <p class="break-word">{{row.total_vote_num}}</p>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          label="Calc#">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <p class="break-word">{{row.calc_num}}</p>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          label="Status#">
          <template #default="{ row }">
            <div class="flex-algin time-text">
              <p
                class="break-word"
                :class="{'color-green':row.status==1}">{{row.status_language}}</p>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          width="50"
          align="center"
          #default="{ row }">
          <template>
            <span
              class="drag-handle"
            >
              <font-awesome-icon
                icon="grip-lines"
                class="drag-handle"
              ></font-awesome-icon>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      :page-size="pageConfig.size"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getTravellerTeamList,sortTravellerTeam} from '@api/pop-traveller-team'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'
import Sortable from 'sortablejs'
export default {
  name: 'touristList',
  components:{
  },
  mixins: [MixinOptions,MinxinFormat],
  data () {
    return {
      draggedRow: null,
      old_index: null,
      team_id: null,
      search: null,
      date: [],
      isShow:false,
      tableData:[],
      team_total:0,
      pageConfig:{
        total: 0,
        currentPage: 1,
        size:60
      },
      sortable: {},
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch:{
  },
  mounted() {
    this.network().getList()
    // let el = this.$refs['sortable']
    // this.createSort(el)
    this.initSortable()
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    initSortable() {
      const el = this.$el.querySelector('.el-table__body-wrapper > table > tbody')
      this.sortable = Sortable.create(el, {
        handle: '.drag-handle', // 指定可拖拽的元素
        animation: 150,
        onStart: (evt) => {
          // 拖拽开始时,记录当前拖拽的元素 ID
          this.team_id = this.tableData[evt.oldIndex].id
        },
        onEnd: (evt) => {
          // 拖拽结束后更新 tableData 的顺序
          const movedItem = this.tableData.splice(evt.oldIndex, 1)[0]
          this.tableData.splice(evt.newIndex, 0, movedItem)
          if(evt.oldIndex != evt.newIndex){
            let params = {
              team_id: this.team_id,
              old_index: evt.oldIndex,
              new_index: evt.newIndex,
            }
            this.network().sortTravellerTeam(params)
          }
        }
      })
    },
    addTeam(){
      this.$router.push('/records/tourist-team/add')
    },
    handleRow(row){
      const { id, class_id, product_id} = row
      this.$router.push(`/records/tourist-team/detail/${id}`)
    },
    handleUpdate(){
      this.isShow = true
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    handleRefresh(){
      this.filterData()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },

    rowClick(row){
    },


    handlerDown() {
      this.network().getList({
        is_export: 1
      })
    },

    network(){
      return {
        getList: async (otherParams) => {
          let params = {
            page: this.pageConfig.currentPage,
            size: this.pageConfig.size,
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res = await getTravellerTeamList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else
          {
            const { data } = await getTravellerTeamList(params)
            this.pageConfig.currentPage = data.current_page
            this.pageConfig.total = data.total
            this.tableData = data.data
            this.team_total = data.total
          }
        },
        sortTravellerTeam: async (params) => {
          const { data } = await sortTravellerTeam(params)
          this.network().getList()
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .break-word{
    word-break: break-word;
  }
  .total{
    .num{
      font-size: 24px;
      font-weight: 400;
      line-height: 36px;
      padding: 0 10px;
    }
  }
  .filter-top{
    margin-top:30px;
    margin-bottom: 30px;
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.yellow {
        background: #E36209;
      }
      &.green {
        background: #28A745;
      }
      &.red {
        background: #D73A49;
      }
    }
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        width: 290px;
      }
      .filter-right {
        padding-left: 10px;
        border-left: 1px solid #E1E4E8;
        flex: 1;
      }
    }
  }
  .transparent{
    .product-name{
      word-break: break-word;
      font-size: 14px;
      font-weight: 600;
    }
    .ref{
      font-size: 12px;
      &>span{
        font-weight: 600;
        padding-right: 5px;
      }
    }
    .no-line{
      text-decoration: none;
      color: #606266;
    }
  }
  .span-status {
    display: inline-block;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.yellow-dark {
      background: #E36209;
    }
    &.red{
      background: #D73A49;
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
      .cell{
        //min-height: 40px;
        line-height: 20px;
        position: relative;
        height: inherit;
        //margin-left: 10px;
        //margin-right: 10px;
        padding: 0;
        color: #24292E;
        //padding: 5px 10px;
        //position: absolute;
        //top: 10px;
        .liter-text{
          color: #6A737D;
          font-size: 12px;
          &.tag-border{
            border: 1px solid #dddfe7;
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
          }
        }
      }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }


}
::v-deep .el-table-column--selection{
  .cell{
    padding-left: 15px!important;
  }
}
.mg-r-8{
  margin-right: 8px;
}
.channel{
  font-size: 12px;
  font-weight: 600;
  color: #586069;
}
.el-table__row.dragging {
  background-color: #f1f1f1;
}
</style>
